import React, { Component, useState, PureComponent } from "react";

import {
  Grid,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  IconButton,
} from "@material-ui/core";
import InputLabel from "@material-ui/core/InputLabel";

import DragIndicatorRoundedIcon from "@material-ui/icons/DragIndicatorRounded";
import { makeStyles } from "@material-ui/core/styles";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import Button from "@material-ui/core/Button";
import ArrowDown from "@material-ui/icons/ArrowDropDown";
import Add from "@material-ui/icons/Add";
import DeleteIcon from "@material-ui/icons/Delete";
import SectionIcon from "@material-ui/icons/AllInclusive";
import ArrowRightIcon from "@material-ui/icons/ArrowRight";
import Popover from "@material-ui/core/Popover";
import Divider from "@material-ui/core/Divider";
import swal from "@sweetalert/with-react";
import GlobalApi from "./../../Global";
import EditIcon from "@material-ui/icons/Edit";
import FormControl from "@material-ui/core/FormControl";
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import Tooltip from "@material-ui/core/Tooltip";
import ArrowOpen from "@material-ui/icons/ArrowDropDownCircle";
import ArrowClose from "@material-ui/icons/PlayCircleFilled";
import Checkbox from "@material-ui/core/Checkbox";
import Colors from "./../../Global/colors";
import DarkButton from "./../../Global/DarkButton";
import LightButton from "./../../Global/LightButton";
import refresh_token from "./../../Global/refresh_token";
import Dialog from "@material-ui/core/Dialog";
import Slide from "@material-ui/core/Slide";
import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import OutlinedInput from "@material-ui/core/OutlinedInput";
import Save from "@material-ui/icons/Save";
import InputAdornment from "@material-ui/core/InputAdornment";
import { useSelector, useDispatch } from "react-redux";
import dots from "../../Assets/dots.png";
import dotsH from "../../Assets/dotsH.png";
import info from "../../Assets/info.png"
import text from "../../Assets/text.png"
import number from "../../Assets/number.png"
import picture from "../../Assets/picture.png"
import annotation from "../../Assets/annotation.png"
import date from "../../Assets/date.png"
import location from "../../Assets/location.png"
import checkbox  from "../../Assets/checkbox.png"
import signature from "../../Assets/signature.png"
import { roundToNearestMinutes } from "date-fns";
import { useTranslation } from "react-i18next";



const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});


function CheckComponent({item,
  classes,
  index,
  selectedDragElementIndex,
  editItem,
  open,
  selectedItemId,
  templateId,
  addNewQuestion,
  handleClick,
  anchorEl,
  handleClose,
  handleClickAway,
  handleChange,
  refreshResponse,
  setReponseInfo,
  responseLibrary,
  clickResponse,
  handleTextChange,
  handleMandatoryCheck,
  handleDelete,
  handleMultiCheck,
  toggleButton,
  toggleButton2,
  unSelect,}) {
const {t} = useTranslation();
  const [title, setTitle] = useState(item?.title)
  const [anchorEl2, setAnchorEl2] = useState(null)

  const handleClose2 = () =>{
    setAnchorEl2(null)
  }

  const handleQuestionAdd = (actionType) => {
    addNewQuestion(
      item.id,
      templateId,
      index,
      actionType,
      "normal"
    );
  };


  return <>
      <Grid container style={{ padding: "5px 5px 0px", position: "relative" }} alignItems="center">
        <Grid item xs={12} style={{ marginBottom: 0 }}>
          <Grid container style={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
            <Grid item>
              <ListItem style={{ marginBottom: 0, paddingTop: 0, paddingBottom: 0 }}>
                <Grid container justifyContent="space-between" alignItems="center">
                  <Grid item alignItems="center" justifyContent="flex-start" style={{ flexDirection: "row" }}>
                    <ListItemIcon style={{ display: "flex", alignItems: "centerd", paddingTop: "5px" }} className={item.isopen == "yes" ? classes.hide : classes.show}>
                      <DragIndicatorRoundedIcon />
                    </ListItemIcon>
                  </Grid>
                  <Grid item alignItems="center" justifyContent="flex-start">
                    <div className={selectedDragElementIndex == index ? classes.hide : classes.show}>
                      <ListItemText className="checklistText" style={{ fontFamily: "ProductSans", marginLeft: item.conditional == "yes" && item.isopen == "no" ? 0 : 0 }} primary={title} />
                    </div>

                    <div className={selectedDragElementIndex == index ? classes.show : classes.hide}>
                      <FormControl variant="outlined" fullWidth size="small">
                        <OutlinedInput id={item.id} className={["customField", "checklistText", { className: classes.textBoxStyle }]} InputProps={{ className: classes.textBoxStyle }} onChange={(e, id) => {
                            // handleTextChange(e, item.id);
                            // this.setState({ title: e.target.value });
                            setTitle(e.target.value);
                          }} value={title //  value={this.state.title}
                          } endAdornment={<InputAdornment position="end">
                              <Tooltip title="Save">
                                <IconButton aria-label="toggle password visibility" onClick={() => {
                                    handleTextChange({ target: { value: title } }, item.id);
                                    unSelect();
                                  }} edge="end">
                                  <Save />
                                </IconButton>
                              </Tooltip>
                            </InputAdornment>} />
                      </FormControl>
                    </div>
                  </Grid>
                  <Grid item className={selectedDragElementIndex == index ? classes.show : classes.hide}>
                    <Tooltip title="Cancel">
                      <IconButton aria-label="toggle password visibility" onClick={() => handleClickAway()}>
                        <HighlightOffIcon />
                      </IconButton>
                    </Tooltip>
                  </Grid>
                </Grid>
              </ListItem>
            </Grid>

            <Grid item style={{ paddingTop: "0px" }}>
              <IconButton aria-label="toggle password visibility" onClick={(e) => {
                  // this.setState({ anchorEl2: e.currentTarget },()=>console.log("anchorEl2",this.state.anchorEl2));
                  setAnchorEl2(e.currentTarget);
                }}>
                <img src={dotsH} alt="open modal" style={{ cursor: "pointer", transform: "rotate(90deg)" }} width={20} />
              </IconButton>

              <Menu id="simple-menu" anchorEl={anchorEl2} keepMounted open={Boolean(anchorEl2)} onClose={handleClose2}>
                <MenuItem className="poppinsFont" style={{ cursor: "pointer" }} onClick={() => {
                    editItem(index);
                    setAnchorEl2(null);
                  }}>
                  Edit
                </MenuItem>
                <MenuItem className="poppinsFont" style={{ cursor: "pointer" }} onClick={() => handleQuestionAdd("new")}>
                  Add Question
                </MenuItem>
                <MenuItem className="poppinsFont" style={{ cursor: "pointer" }} onClick={() => handleDelete(item)}>
                  Delete Question
                </MenuItem>

                <MenuItem className="poppinsFont" style={{ cursor: "pointer" }} onClick={() => handleQuestionAdd("sub")}>
                  Add Sub Question
                </MenuItem>

                {item.dataType == "DateTime" || item.dataType == "Photo" || item.dataType == "Instruction" || item.dataType == "Anotation" || item.dataType == "Location" || item.componentType == "conditional" ? <>

                  </> : <MenuItem className="poppinsFont" style={{ cursor: "pointer" }} onClick={() => handleQuestionAdd("logical")}>
                    Add Conditional Question
                  </MenuItem>}
                <Divider light={true} />
                <MenuItem style={{ cursor: "pointer" }} className="mandatoryCheck">
                  <Checkbox style={{ fontSize: "12px" }} checked={item.mandatory} onClick={() => {
                      handleMandatoryCheck(item);
                    }} value={item.mandatory} inputProps={{ "aria-label": "primary checkbox" }} />
                  <span className="poppinsFont">Mandatory</span>
                </MenuItem>

                {(item.dataType == "Custom" || item.dataType == "Global") && <MenuItem style={{ cursor: "pointer" }} className="mandatoryCheck">
                    <Checkbox style={{ fontSize: "12px" }} checked={item.multiselection} onClick={() => {
                        handleMultiCheck(item);
                      }} inputProps={{ "aria-label": "primary checkbox" }} />
                    <span className="poppinsFont">Multiple selection</span>
                  </MenuItem>}
              </Menu>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} style={{ marginTop: 0 }}>
          <Grid container>
            <Grid item xs={1} alignItems="center" justifyContent="flex-start" />
            <Grid item alignItems="center" justifyContent="flex-start">
              <div className={classes.controlStyle}>
                <div className={classes.root} style={{ overflow: "auto" }}>
                  <div style={{ padding: 0, margin: 0, backgroundColor: "transparent", cursor: "pointer" }} onClick={(e, id) => {
                      handleClick(e, item.id);
                    }}>
                    <DisplayControl selectedControl={item.dataType} responseLibrary={item.responseLibrary} />
                  </div>
                </div>
                {window.innerWidth <= 960 ? <Dialog fullScreen open={open} onClose={() => {
                      handleClose(selectedDragElementIndex);
                    }} TransitionComponent={Transition}>
                    <AppBar className={classes.appBar}>
                      <Toolbar>
                        <DarkButton autoFocus color="inherit" onClick={() => {
                            handleClose(selectedDragElementIndex);
                          }}>
                          Close
                        </DarkButton>
                      </Toolbar>
                    </AppBar>
                    <br />
                    <br />
                    <br />
                    <br />
                    <div>
                      <Response1 props={title} close={handleChange} handleClose={handleClose} openResponse={clickResponse} refreshResponse={refreshResponse} setReponseInfo={setReponseInfo} item={selectedItemId} responseLibrary={responseLibrary} DragIndex={selectedDragElementIndex} mobile={true} />
                    </div>
                  </Dialog> : <Popover style={{ zIndex: 5001 }} open={open} anchorEl={anchorEl} onClose={() => {
                      handleClose(selectedDragElementIndex);
                    }} anchorOrigin={{ vertical: "center", horizontal: "center" }} transformOrigin={{ vertical: "bottom", horizontal: "center" }}>
                    <div>
                      <Response1 props={title} close={handleChange} handleClose={handleClose} openResponse={clickResponse} refreshResponse={refreshResponse} setReponseInfo={setReponseInfo} item={selectedItemId} responseLibrary={responseLibrary} DragIndex={selectedDragElementIndex} mobile={true} />
                    </div>
                  </Popover>}
              </div>
            </Grid>
          </Grid>
        </Grid>

       
        
      </Grid>


     
    </>;
}

export default CheckComponent


const DisplayControl = (props) => {
  var icon = "";
  var color = "";
  const classes = useStylesComponents();
  if (props.selectedControl == "Checkbox") {
    icon = checkbox;
    color = "orange";
  }

  if (props.selectedControl == "Text field") {
    icon = text;
    color = "red";
  }

  if (props.selectedControl == "Number") {
    icon = number;
    color = "#043077";
  }

  if (props.selectedControl == "DateTime") {
    icon = date;
    color = "green";
  }

  if (props.selectedControl == "Photo") {
    icon = picture;
    color = "#00CED1";
  }

  if (props.selectedControl == "Anotation") {
    icon = annotation;
    color = "maroon";
  }

  if (props.selectedControl == "Signature") {
    icon = signature;
    color = "blue";
  }

  if (props.selectedControl == "Location") {
    icon = location;
    color = "#E75480";
  }

  if (props.selectedControl == "Instruction") {
    icon = info;
    color = "#FF00FF";
  }
  return props.selectedControl != "Custom" ? (
    <div className="shadow" style={{display:"flex", alignItems:'center' , backgroundColor:Colors.globalColor9, borderRadius:15, padding:"5px 10px", margin:5}}>
      <img src={icon} width="14" /> &nbsp;
      <p class="innerBox" style={{display:"inline"}}>{props.selectedControl}</p>
          
    </div>
  ) : (
    <div className={classes.responseContainer}>
      {props.responseLibrary?.responses.map((response) => {
        return (
          <div className="shadow" style={{ display: "flex", alignItems: "center", backgroundColor: Colors.globalColor9, borderRadius: 15, padding: "5px 10px" }}>
                        <p class="innerBox" style={{ display: "inline" }}>
                          {response.title}
                        </p>
                      </div>
          // <div className={classes.itemStyle}>
          //   <span className={classes.textStyle}>{response.title}</span>
          // </div>
        );
      })}
    </div>
  );
};

const Response1 = (props) => {
  const {t} = useTranslation();
  console.log("RESPONSE LIBRARY IN COMPONENT))))))))))))))))))))))))))))",props.responseLibrary)
  const closePopup = (controlType, controlID) => {
    props.close(controlType, controlID, "");
  };
  const closeResponsePopup = (controlType, controlID, responseGroupId) => {
    props.close(controlType, controlID, responseGroupId, props.DragIndex);
  };
  const [permissions_obj, setPermissionObj] = useState({});
  const [global, setGlobalLibary] = useState(() => {
    var responseLibrary = [...props.responseLibrary];
    var list = responseLibrary.filter((x) => x.identifier == "Global");
    return list;
  });
  const [custom, setCustomLibary] = useState(() => {
    var responseLibrary = [...props.responseLibrary];
    var list = responseLibrary.filter((x) => x.identifier == "Custom");
    return list;
  });
  let userData = useSelector((state) => state.userReducer.user);
  let company = useSelector((state) => state.companyReducer.company);


  React.useEffect(
    () => {
      getPermissions();
    },
    [company?.id]
  );

  const getPermissions = () => {
    console.log("$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$");
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data?.token;
    if (data !== null) {
      let params = { company_id: company?.id, user_id: data?.user_id };
      let query = Object.keys(params)
        .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
        .join("&");

      fetch(GlobalApi + "/User/get_user_permission_of_company?" + query, {
        method: "GET",
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        },
      })
        .then((responseJson) => responseJson.json())
        .then(async (response) => {
          console.log(response);
          if (response.msg === "success") {
            let permissionsObj = {};
            await response.data.map((v) => {
              permissionsObj[(v?.title)] = true;
            });
            console.log("Permissions Obj >>>>>>>", permissionsObj);

            setPermissionObj(permissionsObj);
          } else if (
            response.error === "jwt expired" ||
            response.error === "invalid token" ||
            response.error === "invalid signature" ||
            response.error === "jwt malformed" ||
            response.error === "Unexpected token"
          ) {
            let status = await refresh_token();
            // console.log(status);
            if (status) {
              // console.log("opopopop");
              getPermissions();
            }
          }
        })
        .catch((error) => {
          // localStorage.clear();
          // window.location.replace("/signin");
          console.log("FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFF", error.message);
        });
    }
  };




  const clickResponse = (e) => {
    props.handleClose();
    e.preventDefault();
    props.openResponse(true, "new");
  };
  const onEdit = (id) => {
    props.setReponseInfo("edit", id);
  };

  const onDelete =(resId) =>{
    console.log("RESID______________________________",resId)
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data.token;
    let params = {
      response_id: resId,
    };

    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");

    fetch(GlobalApi + "/Response/delete_response?" + query, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    })
      .then((responseJson) => responseJson.json())
      .then((response) => {
        console.log("response________________",response);
        if(response.msg == 'success'){
          swal(t("Success"), t("Response has been Deleted"), "success");
          props.refreshResponse()
        //  fetchResponse()
        }
        else{
          swal(t("Warning"), response.error, "error");
        }
        
      })
      .catch((error) => console.log("error",error));
  }


  const classes = useStylesComponents();
  return <Grid container className="selectBox" style={{ overflow: "hidden", maxWidth: "330px" }} >
      <Accordion style={{ width: "100%" }}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header">
          
          <p className="accordianTitle">
          Basic Fields
          </p>
        </AccordionSummary>
        <AccordionDetails>
          <Grid container spacing={1}>
            <Grid item xs={6}>
              <MenuItem style={{padding:"5px",border:'1px dashed #043077', borderRadius:"5px" }} value="Text field" onClick={() => {
                  closePopup("Text field", props.item);
                }}>
               <img src={text} width="14" /> &emsp; <p class="innerBox">Text</p>
              </MenuItem>
            </Grid>
            <Grid item xs={6}>
              <MenuItem style={{padding:"5px",border:'1px dashed #043077', borderRadius:"5px" }}    value="Number" onClick={() => {
                  closePopup("Number", props.item);
                }}
              >
                <img src={number} width="14" /> &emsp;  <p class="innerBox">Number</p>
              </MenuItem>
            </Grid>

            <Grid item xs={6}>
              <MenuItem style={{padding:"5px",border:'1px dashed #043077', borderRadius:"5px" }}  value="Checkbox"
                onClick={() => {
                  closePopup("Checkbox", props.item);
                }}
              >
                <img src={checkbox} width="14" /> &emsp; 
                <p class="innerBox">Checkbox</p>
              </MenuItem>
            </Grid>
            <Grid item xs={6}>
              <MenuItem style={{padding:"5px",border:'1px dashed #043077', borderRadius:"5px" }} value="DateTime"
                onClick={() => {
                  closePopup("DateTime", props.item);
                }}
              >
               <img src={date} width="14" /> &emsp; 
                <p class="innerBox">Date/Time</p>
              </MenuItem>
            </Grid>
            <Grid item xs={6}>
              <MenuItem style={{padding:"5px",border:'1px dashed #043077', borderRadius:"5px" }}  value="Photo"
                onClick={() => {
                  closePopup("Photo", props.item);
                }}
              >
                <img src={picture} width="14" /> &emsp; 
                <p class="innerBox">Image</p>
              </MenuItem>
            </Grid>
            <Grid item xs={6}>
              <MenuItem style={{padding:"5px",border:'1px dashed #043077', borderRadius:"5px" }}  value="Anotation"
                onClick={() => {
                  closePopup("Anotation", props.item);
                }}
              >
               <img src={annotation} width="14" /> &emsp; 
                <p class="innerBox">Annotation</p>
              </MenuItem>
            </Grid>
            <Grid item xs={6}>
              <MenuItem style={{padding:"5px",border:'1px dashed #043077', borderRadius:"5px" }}   value="Signature"
                onClick={() => {
                  closePopup("Signature", props.item);
                }}
              >
               <img src={signature} width="14" /> &emsp; 
                <p class="innerBox">Signature</p>
              </MenuItem>
            </Grid>
            <Grid item xs={6}>
              <MenuItem style={{padding:"5px",border:'1px dashed #043077', borderRadius:"5px" }}       value="Location"
                onClick={() => {
                  closePopup("Location", props.item);
                }}
              >
               <img src={location} width="14" /> &emsp; 
                <p class="innerBox">Location</p>
              </MenuItem>
            </Grid>

            <Grid item xs={6}>
              <MenuItem style={{padding:"5px",border:'1px dashed #043077', borderRadius:"5px" }}  value="Instruction"
                onClick={() => {
                  closePopup("Instruction", props.item);
                }}
              >
                <img src={info} width="14" /> &emsp; 
                <p class="innerBox">Instruction</p>
              </MenuItem>
            </Grid>


        
           
          </Grid>
          
        </AccordionDetails>
      </Accordion>
      <Accordion style={{ width: "100%" }}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel2a-content" id="panel2a-header" style={{justifyContent:'space-between'}}>
            <p className="accordianTitle">
          Multiple Choice Responses
          </p>

          {userData?.super_admin == true || permissions_obj["Admin"] == true || permissions_obj["Manage Response Sets"] == true ?
            <Button
            size="small"  
            className="startInspectionBtnSmall"
            style={{ backgroundColor: Colors.globalColor8,marginLeft:'5px' }}
            onClick={(e)=>clickResponse(e)}
          >
            + Response
          </Button>: <Button
                          size="small"
                          className="startInspectionBtnSmall2"
                          disabled
                          style={{ backgroundColor: "grey",marginLeft:'5px' }}
                        >
                          + Response
                        </Button>}
          

                           
        </AccordionSummary>
        <AccordionDetails>
         <div className="scrollbarShow2" style={{height:'100px', overflowY:'auto'}}>
         {custom.map((group) => {
            return (
              <div className={classes.container2} style={{width:'100%'}}>
          
                <MenuItem
                  value="Checkbox"
                  className={classes.container2}
                  onClick={() => {
                    closeResponsePopup("Custom", props.item, group.id);
                  }}
                  style={{ overflow: "hidden" }}
                >
                  {group.responses.map((item) => {
                    return <div className="shadow" style={{ display: "flex", alignItems: "center", backgroundColor: Colors.globalColor9, borderRadius: 15, padding: "5px 10px" }}>
                        <p class="innerBox" style={{ display: "inline" }}>
                          {item.title}
                        </p>
                      </div>;
                      // <div className={classes.itemStyle}>
                      //   <span className={classes.textStyle}>{item.title}</span>
                      // </div>
                  })}
                </MenuItem>
           
                <div style={{display:"flex", alignItems:'center',justifyContent:'center', marginLeft:"10px"}}>
                {userData?.super_admin == true || permissions_obj["Admin"] == true || permissions_obj["Manage Response Sets"] == true ?
                <ListItemIcon
                  style={{ cursor: "pointer", minWidth:'0' }}
                  onClick={() => {
                    onEdit(group.id);
                  }}
                >
                  <EditIcon style={{ color:  Colors.globalColor8, fontSize:'18px' }} />
                </ListItemIcon> :
                <ListItemIcon
                style={{ cursor: "pointer", minWidth:'0' }}
              >
                <EditIcon style={{ color:'#dadada',fontSize:'18px'}} />
              </ListItemIcon>}


              {userData?.super_admin == true || permissions_obj["Admin"] == true || permissions_obj["Manage Response Sets"] == true ?
                <ListItemIcon
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    onDelete(group.id);
                  }}
                >
                  <DeleteIcon style={{ color: Colors.globalColor8,fontSize:'18px' }} />
                </ListItemIcon> :
                <ListItemIcon
                style={{ cursor: "pointer" }}
              >
                <DeleteIcon style={{ color: "#dadada",fontSize:'18px' }} />
              </ListItemIcon>}
              </div>
              </div>
            );
          })}
           </div>
        </AccordionDetails>
      </Accordion>
      <Accordion style={{ width: "100%" }}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel2a-content" id="panel2a-header">           <p className="accordianTitle">
           Global Responses
          </p>
        </AccordionSummary>
        <AccordionDetails>
        <div className="scrollbarShow2" style={{height:'100px', overflowY:'auto',width:"100%"}}>
        {global.map((group) => {
            return (
              <div className={classes.container2}>
                <MenuItem
                  value="Checkbox"
                  className={classes.container2}
                  onClick={() => {
                    closeResponsePopup("Custom", props.item, group.id);
                  }}
                  style={{ overflow: "auto" }}
                >
                  <div className="shadow" style={{ display: "flex", alignItems: "center", backgroundColor: Colors.globalColor9, borderRadius: 15, padding: "5px 10px" }}>
                        <p class="innerBox" style={{ display: "inline" }}>
                          {group.title}
                        </p>
                      </div>
                  {/* {
              
                    <div className={classes.itemStyle}>
                      <span className={classes.textStyle}>{group.title}</span>
                    </div>
                   
                  } */}
                </MenuItem>
              </div>
            );
          })}
           </div>
        </AccordionDetails>
      </Accordion>

      {/* <Grid item xs={12} sm={6}>
        <div
          className={props.mobile ? null : classes.containerResponses}
          style={{
            overflow: "auto",
            height: window.innerWidth <= 960 ? "100%" : 400,
            maxWidth: 350,
          }}
        >
          <div className={classes.headingContainer}>
            <div style={{ fontFamily: "ProductSans", color: "gray" }}>
            Multiple choice responses
            </div>

            {userData?.super_admin == true || permissions_obj["Admin"] == true || permissions_obj["Manage Response Sets"] == true ?
            <div
              style={{
                fontFamily: "sans-serif",
                color: "#043077",
                cursor: "pointer",
              }}
              onClick={clickResponse}
            >
              +Responses
            </div>:<div
              style={{
                fontFamily: "sans-serif",
                color: "#dadada",
                cursor: "pointer",
              }}
            >
              +Responses
            </div>}
          </div>
          {custom.map((group) => {
            return (
              <div className={classes.container2}>
                <MenuItem
                  value="Checkbox"
                  className={classes.container2}
                  onClick={() => {
                    closeResponsePopup("Custom", props.item, group.id);
                  }}
                  style={{ overflow: "auto" }}
                >
                  {group.responses.map((item) => {
                    return (
                      <div className={classes.itemStyle}>
                        <span className={classes.textStyle}>{item.title}</span>
                      </div>
                    );
                  })}
                </MenuItem>
                {userData?.super_admin == true || permissions_obj["Admin"] == true || permissions_obj["Manage Response Sets"] == true ?
                <ListItemIcon
                  style={{ cursor: "pointer", minWidth:'0' }}
                  onClick={() => {
                    onEdit(group.id);
                  }}
                >
                  <EditIcon style={{ color:  Colors.globalColor8 }} />
                </ListItemIcon> :
                <ListItemIcon
                style={{ cursor: "pointer", minWidth:'0' }}
              >
                <EditIcon style={{ color:'#dadada'}} />
              </ListItemIcon>}


              {userData?.super_admin == true || permissions_obj["Admin"] == true || permissions_obj["Manage Response Sets"] == true ?
                <ListItemIcon
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    onDelete(group.id);
                  }}
                >
                  <DeleteIcon style={{ color: Colors.globalColor8 }} />
                </ListItemIcon> :
                <ListItemIcon
                style={{ cursor: "pointer" }}
              >
                <DeleteIcon style={{ color: "#dadada" }} />
              </ListItemIcon>}
              </div>
            );
          })}

          <Divider style={{ height: 1, backgroundColor: "#C2C5CC" }} />
          <div className={classes.headingContainer}>
            <div style={{ fontFamily: "ProductSans", color: "gray" }}>
              Global Response Set
            </div>
          
          </div>
          {global.map((group) => {
            return (
              <div className={classes.container2}>
                <MenuItem
                  value="Checkbox"
                  className={classes.container2}
                  onClick={() => {
                    closeResponsePopup("Custom", props.item, group.id);
                  }}
                  style={{ overflow: "auto" }}
                >
                  {
              
                    <div className={classes.itemStyle}>
                      <span className={classes.textStyle}>{group.title}</span>
                    </div>
                   
                  }
                </MenuItem>
              </div>
            );
          })}
        </div>
      </Grid>
      <Grid item xs={12} sm={6}>
        <div
          className={props.mobile ? null : classes.containerResponses}
          style={{
            overflow: "auto",
            height: window.innerWidth <= 960 ? "100%" : 400,
          }}
        >
          <div className={classes.response1Style}>
            <div>
              <MenuItem
                style={{
                  paddingTop: 6.59,
                  lineHeight: 1.86666,
                  fontFamily: "ProductSans",
                }}
                value="Text field"
                onClick={() => {
                  closePopup("Text field", props.item);
                }}
              >
                <span class="material-icons" style={{ color: "red" }}>
                  title
                </span>{" "}
                Text answer
              </MenuItem>
              <MenuItem
                style={{
                  paddingTop: 6.59,
                  lineHeight: 1.86666,
                  fontFamily: "ProductSans",
                }}
                value="Number"
                onClick={() => {
                  closePopup("Number", props.item);
                }}
              >
                <span class="material-icons">filter_9</span> Number
              </MenuItem>
              <MenuItem
                style={{
                  paddingTop: 6.59,
                  lineHeight: 1.86666,
                  fontFamily: "ProductSans",
                }}
                value="Checkbox"
                onClick={() => {
                  closePopup("Checkbox", props.item);
                }}
              >
                <span class="material-icons" style={{ color: "orange" }}>
                  check_circle
                </span>{" "}
                Checkbox
              </MenuItem>
            </div>
            <Divider style={{ height: 1, backgroundColor: "#C2C5CC" }} />
          </div>
          <div className={classes.response1Style}>
            <div>
              <MenuItem
                style={{
                  paddingTop: 6.59,
                  lineHeight: 1.86666,
                  fontFamily: "ProductSans",
                }}
                value="DateTime"
                onClick={() => {
                  closePopup("DateTime", props.item);
                }}
              >
                <span class="material-icons" style={{ color: "green" }}>
                  date_range
                </span>{" "}
                DateTime
              </MenuItem>
             
              <MenuItem
                style={{
                  paddingTop: 6.59,
                  lineHeight: 1.86666,
                  fontFamily: "ProductSans",
                }}
                value="Photo"
                onClick={() => {
                  closePopup("Photo", props.item);
                }}
              >
                <span class="material-icons" style={{ color: "#00CED1" }}>
                  insert_photo
                </span>{" "}
                Photo
              </MenuItem>
              <MenuItem
                style={{
                  paddingTop: 6.59,
                  lineHeight: 1.86666,
                  fontFamily: "ProductSans",
                }}
                value="Anotation"
                onClick={() => {
                  closePopup("Anotation", props.item);
                }}
              >
                <span class="material-icons" style={{ color: "maroon" }}>
                  brush
                </span>{" "}
                Anotation
              </MenuItem>
              <MenuItem
                style={{
                  paddingTop: 6.59,
                  lineHeight: 1.86666,
                  fontFamily: "ProductSans",
                }}
                value="Signature"
                onClick={() => {
                  closePopup("Signature", props.item);
                }}
              >
                <span class="material-icons" style={{ color: "blue" }}>
                  gesture
                </span>{" "}
                Signature
              </MenuItem>
              <MenuItem
                style={{
                  paddingTop: 6.59,
                  lineHeight: 1.86666,
                  fontFamily: "ProductSans",
                }}
                value="Location"
                onClick={() => {
                  closePopup("Location", props.item);
                }}
              >
                <span class="material-icons" style={{ color: "#E75480" }}>
                  add_location
                </span>{" "}
                Location
              </MenuItem>
            </div>
            <Divider style={{ height: 1, backgroundColor: "#C2C5CC" }} />
          </div>
          <div className={classes.response1Style}>
            <div>
              <MenuItem
                style={{
                  paddingTop: 6.59,
                  lineHeight: 1.86666,
                  fontFamily: "ProductSans",
                }}
                value="Instruction"
                onClick={() => {
                  closePopup("Instruction", props.item);
                }}
              >
                <span class="material-icons" style={{ color: "#FF00FF" }}>
                  feedback
                </span>{" "}
                Instruction
              </MenuItem>
            </div>
            <Divider style={{ height: 1, backgroundColor: "#C2C5CC" }} />
          </div>
        </div>
      </Grid> */}
    </Grid>;
};

const useStylesComponents = makeStyles((theme) => ({
  response1Style: {
    //marginRight:5,
    //marginBottom:5,
  },
  root: {
    // display: "flex",
    // flexDirection: "row",
    // justifyContent: "space-between",
    width: "100%",
  },
  container: {
    display: "flex",
    flexDirection: "column",
    //justifyContent:'space-between',
    width: "100%",
    overflow: "auto",
    borderLeft: "1px solid #C2C5CC",
    // height: "80%"
  },
  container2: {
    display: "flex",
    flexDirection: "row",
    marginBottom: 2,
    width: "100%",
  },
  containerResponses: {
    display: "flex",
    flexDirection: "column",
    height: "90%",
    overflow: "auto",
    width: "100%",
  },
  headingContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 5,
    padding: 10,
  },
  cardColorStyle1: {
    //backgroundColor:'#FDD835',
    borderBottom: "1px solid #C2C5CC",
    borderLeft: "1px solid #C2C5CC",
    width: "100%",
  },
  cardColorStyle2: {
    //backgroundColor:'#F0F4C3',
    borderBottom: "1px solid #C2C5CC",
    borderLeft: "1px solid #C2C5CC",
  },
  cardColorStyle3: {
    //backgroundColor:'#4594b8'
    borderBottom: "1px solid #C2C5CC",
    borderLeft: "1px solid #C2C5CC",
  },
  itemStyle: {
    borderRadius: 10,
    backgroundColor: "#eaf7fe",
    // borderWidth:'thin',
    // border:'1px solid',
    marginRight: 5,
    padding: 5,
    alignSelf: "center",
  },
  textStyle: {
    fontSize: 12,
    color: "black",
  },
  responseContainer: {
    display: "flex",
    flexDirection: "row",
    marginBottom: 5,
    padding: 10,
  },
  displayControlStyle: {
    padding: 10,
  },
  menuContainer: {
    width: 60,
    borderRadius: 10,
    //backgroundColor:'lightgray',
    backgroundColor: "#FFFFFF",
    display: "flex",
    flexDirection: "column",
    zIndex: 100,
    top: 0,
    left: -80,
    position: "absolute",
    border: "1px solid",
    borderColor: "lightgray",
    justifyContent: "center",
    borderRadius: 5,
  },
  arrowContainer: {
    width: 30,
    zIndex: 100,
    top: 10,
    left: 50,
    position: "absolute",
  },
  hide: {
    display: "none",
  },
  optionContainer: {
    display: "flex",
    flexDirection: "column",
    marginBottom: 5,
  },
  optionItemStyle: {
    textAlign: "center",
    fontSize: 14,
    marginTop: -10,
  },
  formControl: {
    marginLeft: theme.spacing(1),
    minWidth: 120,
  },
  selectEmpty: {
    //marginTop: -theme.spacing(0.5),
  },
  Icon: {
    width: 30,
    alignSelf: "center",
    cursor: "pointer",
  },
  blankContainer: {
    display: "flex",
    flexDirection: "row",
    marginLeft: 16,
    marginTop: -22,
  },
  showConditionalTextBox: {
    marginLeft: 16,
    marginTop: -22,
  },
  textBoxStyle: {
    //marginLeft:-theme.spacing.unit*12,
    paddingLeft: theme.spacing.unit,
    height: 30,
  },
  divTypoStyle: {
    width: "100%",
    //justifyContent:'center'
  },
}));

const MobileOptions = (props) => {
  const classes = useStylesComponents();
  const handleClick = (actionType) => {
    console.log(
      props.checkListItemId,
      props.templateId,
      props.controlIndex,
      actionType,
      props.componentType
    );

    props.addNewQuestion(
      props.checkListItemId,
      props.templateId,
      props.controlIndex,
      actionType,
      props.componentType
    );
  };
  return (
    <Grid
      container
      className={props.controlIndex == props.dragIndex ? null : classes.hide}
      style={{ padding: 5 }}
    >
      <Grid item xs={6} style={{ padding: 3 }}>
        <LightButton
          fullWidth
          onClick={() => {
            handleClick("new");
          }}
        >
          <Add
          // style={{ width: 30, height: 30, marginTop: 0, color: "#043077" }}
          />
          Question
        </LightButton>
      </Grid>

      <Grid
        item
        xs={6}
        className={
          props.dataType == "DateTime" ||
          props.dataType == "Photo" ||
          props.dataType == "Instruction" ||
          props.dataType == "Anotation" ||
          props.dataType == "Location" ||
          props.componentType == "conditional"
            ? classes.hide
            : null
        }
        style={{ padding: 3 }}
      >
        <LightButton
          fullWidth
          onClick={() => {
            handleClick("logical");
          }}
        >
          <SectionIcon
          // style={{ width: 30, height: 30, marginTop: 0, color: "orange" }}
          />
          Logic
        </LightButton>
      </Grid>
    </Grid>
  );
};

const Options = (props) => {
  const classes = useStylesComponents();
  const handleClick = (actionType) => {
    console.log(
      props.checkListItemId,
      props.templateId,
      props.controlIndex,
      actionType,
      props.componentType
    );
    props.addNewQuestion(
      props.checkListItemId,
      props.templateId,
      props.controlIndex,
      actionType,
      props.componentType
    );
  };
  return (
    <div
      className={
        props.controlIndex == props.dragIndex
          ? classes.menuContainer
          : classes.hide
      }
    >
      <div className={classes.arrowContainer}>
        <ArrowRightIcon style={{ width: 30, height: 30, marginTop: 0 }} />
      </div>
      <div className={classes.optionContainer}>
        <IconButton
          style={{ width: 30, height: 30, alignSelf: "center" }}
          onClick={() => {
            handleClick("new");
          }}
        >
          <Add
            style={{ width: 30, height: 30, marginTop: 0, color: "#043077" }}
          />
        </IconButton>
        <span className={classes.optionItemStyle}>Question</span>
      </div>

      <div
        className={
          props.dataType == "DateTime" ||
          props.dataType == "Photo" ||
          props.dataType == "Instruction" ||
          props.dataType == "Anotation" ||
          props.dataType == "Location" ||
          props.componentType == "conditional"
            ? classes.hide
            : classes.optionContainer
        }
      >
        <IconButton
          style={{ width: 30, height: 30, alignSelf: "center" }}
          onClick={() => {
            handleClick("logical");
          }}
        >
          <SectionIcon
            style={{ width: 30, height: 30, marginTop: 0, color: "orange" }}
          />
        </IconButton>
        <span className={classes.optionItemStyle}>Logic</span>
      </div>
    </div>
  );
};
